import http from "../../http";

const prize = {
    getSimplePrizeItemList(param){
        return http.get("/gateway/api/sycomponent/pc/simplePrize/getSimplePrizeItemList", param);
    },
}
export default prize